import React, { useEffect, useState } from 'react';
import { coachScreenOpen } from '../Simplify360Chat/Services/HWIframeBridge';
import { s360ConfigService } from '../Simplify360Chat/Services/S360Config';
import PackDescriptionComponent from './FormFields/PackDesription/PackDescriptionComponent';
import HelpAssistant from './HelpAssistant/HelpAssistant';

const Simplify360Tatasky = (props) => {

    // console.log("props from config in S360TATASKY.JS",props)
    const [idleTime, setIdleTime] = useState(false)
    const [name, setName] = useState()
    const [login, setLogin] = useState(false)
    const [loginLoader, setLoginLoader] = useState(true);
    const [loginCount,setLoginCount]= useState(0)
    useEffect(() => {
       
        coachScreenOpen();
        localStorage.removeItem("linkChatOnce") 
        localStorage.removeItem("linkLoginOnce")
    }, [])
    window.addEventListener('message', function(event) {
     
    });
    useEffect(()=>{ 
console.log("loginCount",props.loginCount)
setLoginCount(props.loginCount)
},[props])
    const isConfigured = s360ConfigService.isConfigured();
    // console.log(isConfigured,"s360")
   
    return (
        <>
            { isConfigured ? (<><HelpAssistant loginCount={loginCount}    idleTime={idleTime} name={name} login={login} loginLoader={loginLoader} authenticated = {props.authenticated} action={props.action} {...props} /></>) : (<div>
               
            </div>)}

        </>
    )
}



export default Simplify360Tatasky;